"use client";
import Login from "./content";
import { signIn } from "next-auth/react";
import { useEffect, useRef } from "react";

const LoginMask: React.FC<{ loginToken: string }> = ({ loginToken }) => {
  const run = useRef(0);
  useEffect(() => {
    if (loginToken && run.current === 0) {
      signIn("credentials", {
        token: loginToken,
        callbackUrl: "/account",
        redirect: true,
      });
      run.current++;
    }
  }, []);

  return <Login />;
};
export default LoginMask;
